module.exports = __webpack_public_path__ + "img/userB20.784cd3a4.jpg";